import statesOptions from '../data/states.json';
import validations from '../data/validations.json';

GetStartedController.$inject = [
  'ApplicationService',
  '$document',
  '$routeParams',
  '$scope',
  '$rootScope',
  '$location',
  '$window'
];

function GetStartedController (ApplicationService, $document, $routeParams, $scope, $rootScope, $location, $window) {
  function init () {
    $document[0].title = 'Delta Dental - Agent Appointment Application';
    $rootScope.previouslyAppointed = false;
    var formData = ApplicationService.getBaseData(false);
    $scope.brokerInformation = formData.brokerInformation;
    $scope.selectedStates = formData.selectedStates || {};
    $scope.validations = validations;
    $scope.statesOptions = statesOptions;
    $scope.submitForm = submitForm;
    $scope.selectedOneState = selectedOneState;
    $scope.currentSite = ApplicationService.getCurrentSite();
    $scope.contactEmail = 'DDMNBroker@DeltaDentalMN.org';
    if ($scope.currentSite === 'ne') {
      $scope.contactEmail = 'DDNEBroker@DeltaDentalNE.org';
    }
  }

  function selectedStatesNum () {
    var state;
    for (state in $scope.selectedStates) {
      if ($scope.selectedStates[state]) {
        return true;
      }
    }
    return false;
  }

  function selectedOneState () {
    return selectedStatesNum() > 0;
  }

  function submitForm (form) {
    var formData = ApplicationService.getBaseData(false);
    var agencyInformation = formData.agencyInformation;
    switch ($routeParams.agency) {
      case 'directbenefits':
        agencyInformation.generalAgencyName = 'Direct Benefits';
        agencyInformation.autoCompletedGeneralAgencyName = true;
        break;
      case 'ociinsurance':
        agencyInformation.generalAgencyName = 'OCI Insurance';
        agencyInformation.autoCompletedGeneralAgencyName = true;
        break;
      case 'financialservicesinc':
        agencyInformation.generalAgencyName = 'Financial Services, Inc';
        agencyInformation.autoCompletedGeneralAgencyName = true;
        break;
    
      default:
        break;
    }
    
    var npnNumber = $scope.brokerInformation.npn;
    if (form.$valid) {
      $scope.npnError = false;
      $scope.loading = true;
      var data = {
        'brokerInformation': $scope.brokerInformation,
        'selectedStates': $scope.selectedStates,
        'agencyInformation': agencyInformation,
        'previouslyAppointed': false
      };
      ApplicationService.setData(data, true);
      ApplicationService.validateNpn(npnNumber).then(function () {
        $location.path('/application/broker-information'); 
      }, function () {
        $scope.loading = false;
        $scope.npnError = true;
        $window.scrollTo(0, 0);
      });
    }
  }

  init();
}

export default GetStartedController;



//////////////////
// WEBPACK FOOTER
// ./src/js/controllers/GetStartedController.js
// module id = 22
// module chunks = 0